<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                        <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="query.company_id" placeholder="婚庆执行公司" filterable clearable class="handle-input mr10">
                        <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-select v-model="query.planer_id" placeholder="请选择策划师" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in plannerList" :key="index" :label="item.realname" :value="item.id"></el-option>
                    </el-select>
                    <el-input v-model="query.keywords" placeholder="手机号/客户姓名/微信号" clearable class="handle-input mr10"></el-input>
                    <el-select v-model="query.item_check_status1" placeholder="请选择审核状态" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in auditStatus " :key="index" :label="item.title" :value="item.id"></el-option>
                    </el-select>
                    <el-button type="primary" class="btn-search ml8" @click="searchTableData">搜索</el-button>
                    <el-popover placement="bottom" width="600" trigger="click">
                        <div class="help-container">
                            <div>
                                <el-tag type="danger">待分配状态</el-tag>
                                <dl class="help-box">
                                    <dt>待分配:</dt>
                                    <dd>待分配</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">已派单状态</el-tag>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[待审核]:</dt>
                                    <dd>已派单-[待审核]</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[审核驳回]:</dt>
                                    <dd>已派单-[审核驳回]</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[审核通过]:</dt>
                                    <dd>已派单-[审核通过]</dd>
                                </dl>
                            </div>
                        </div>
                        <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <!-- 搜索E -->
        <!-- 类型切换S -->
        <div class="nav-check-status">
            <el-radio-group v-model="query.work_status" @change="changeHandler">
                <el-radio-button label="0">待分配</el-radio-button>
                <el-radio-button label="1">分派中</el-radio-button>
                <el-radio-button label="2">已派单</el-radio-button>
                <!-- <el-radio-button label="2">分派中</el-radio-button>
            <el-radio-button label="3">已完成</el-radio-button>
            <el-radio-button label="4">已作废</el-radio-button> -->
            </el-radio-group>
        </div>
        <!-- 类型切换E -->
        <div class="table-box">
            <el-table :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading">
                <el-table-column prop="status" label="派单状态" align="center">
                    <template slot-scope="scope">
                        <el-link type="danger" @click="showDrawerPass(_self, 'addView', 'showDrawer', [scope.row])" v-if="scope.row.status == 0 && scope.row.item_check_status1<0">待分配
                            <template v-if="scope.row.work_status =='1'">[派单中]</template>
                        </el-link>
                        <el-link type="danger" @click="showDrawerPass(_self, 'addView', 'showDrawer', [scope.row])" v-if="scope.row.status == 0 && scope.row.item_check_status1>=0 ">已派单-[{{getItemCheckTitle(scope.row.item_check_status1)}}]</el-link>
                        <!-- <el-link type="danger" @click="showDrawerPass(_self, 'addView', 'showDrawer', [scope.row])" v-else-if="scope.row.status == 2">已确定</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'addView', 'showDrawer', [scope.row])" v-else-if="scope.row.status == 3">重新派单中-[{{getItemCheckTitle(scope.row.item_check_status1)}}]</el-link>
                    <el-link type="danger" @click="showDrawerPass(_self, 'addView', 'showDrawer', [scope.row])" v-else-if="scope.row.status == 4">已作废-[{{getItemCheckTitle(scope.row.item_check_status2)}}]</el-link> -->
                    </template>
                </el-table-column>
                <el-table-column prop="wedding.company" label="婚庆承办公司" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order.event_date" label="婚期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order.hotel" label="酒店" show-overflow-tooltip></el-table-column>
                <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
                <el-table-column prop="order.bridegroom" label="客户姓名"></el-table-column>
                <el-table-column prop="planner" label="策划师"></el-table-column>
                <el-table-column prop="create_time" label="提交时间" align="center"></el-table-column>
            </el-table>
        </div>
        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="download"></div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.totals"></el-pagination>
            </div>
        </div>

        <add-view ref="addView"></add-view>
    </div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import addView from './detail.vue';
const query = {
    news_type: "",
    type: "control_project",
    company_id: "", // 婚庆执行公司
    hotel_id: "", // 举办酒店
    keywords: "", //手机号/客户姓名/微信号
    planner_id: "", // 策划编号
    date_range: [], //开始结束时间
    work_status: "0",
    item_check_status1: ""
};
export default {
    components: {
        addView,
    },
    data() {
        let tableHeight = window.innerHeight - 300;
        let windowheight = window.innerHeight;
        return {
            plannerList: [],
            query: Object.assign({}, query), // 搜索条件
            tableData: [],
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            auditStatus: [{
                id: "0",
                title: "待审核"
            },
            {
                id: "1",
                title: "审核中"
            },
            {
                id: "2",
                title: "审核通过"
            },
            {
                id: "3",
                title: "审核驳回"
            },
            ]
        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    beforeCreate() {
        this.dictionary = dictionary;
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle
    },
    created() {
        this.getTableData();
        this.getPlannerList();
    },
    methods: {
        changeHandler(value) {
            this.query.work_status = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        searchTableData() {
            this.pagination.page = 1;
            this.getTableData();
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            let url = '/api/wedding.demand/index';
            let query = this.query;
            query.pagination = _this.pagination;
            this.$post(url, query).then(res => {
                _this.tableData = res.data.list;
                _this.pagination = res.data.pagination;
                _this.loading = false
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getPlannerList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: [32, 35]
            };
            _this.$post(url, params).then((res) => {
                _this.plannerList = res.data.list;
            });
        }
    }
}
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
